import { render, staticRenderFns } from "./CampaignPolicy.vue?vue&type=template&id=cd3a2308&scoped=true"
import script from "./CampaignPolicy.vue?vue&type=script&lang=js"
export * from "./CampaignPolicy.vue?vue&type=script&lang=js"
import style0 from "./CampaignPolicy.vue?vue&type=style&index=0&id=cd3a2308&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd3a2308",
  null
  
)

export default component.exports